import { APPOINTMENT_REQUIREMENTS_ROOT_KEY } from '../../constants';

export const ACTION_PREFIX = '@@requirementsform';
export const ROOT_STATE_KEY = APPOINTMENT_REQUIREMENTS_ROOT_KEY;
export const ADDRESS_FORM_STATE_KEY = 'addressform';
export const PRIMARY_CARE_CONFIRMATION_STATE_KEY = 'primaryCareConfirmation';
export const USING_INSURANCE_STATE_KEY = 'usingInsuranceConfirmation';
export const OBGYN_CONFIRMATION_STATE_KEY = 'obgynConfirmation';
export const REFERRING_PHYSICIAN_STATE_KEY = 'referringPhysician';
export const AGE_WARNING_CONFIRMATION_STATE_KEY = 'ageWarningConfirmation';
export const REQUIREMENTS_VALIDATION_KEY = 'isValid';
export const OBGYN_WARNING = 'obgyn_warning';
export const ADDRESS_CONFIRMATION = 'address_confirmed';
export const APPOINTMENT_TIME = 'appointment_time';
export const AGE_WARNING = 'age_warning';
export const PRIMARY_CARE_WARNING = 'pcp_warning';
export const INSURANCE_NOT_TAKEN_WARNING = 'insurance_not_taken_warning';
export const USING_INSURANCE_WARNING = 'using_insurance_warning';
export const IN_NETWORK_ONLY_REQUIREMENT = 'in_network_only_requirement';
export const INSURANCE_ID_REQUIRED = 'insurance_required';
export const REFERRAL_REQUIRED = 'referral';
export const PHONE_REQUIRED = 'patient_id';
// COVID-19 requirements
export const CORONA_SCREEN_SYMPTOMS = 'corona_screen_symptoms';

export const FIELD_ERROR_CODES = {
    PATIENT_TIMES_OVERLAP: 'PatientTimesOverlap',
    PHONE_IS_VERIFIED_FAILURE: 'PhoneIsVerifiedFailure',
};

export const GaActionText = {
    trackSelectAddress1: 'Select Address Form Address 1',
    trackSelectAddress2: 'Select Address Form Address 2',
    trackSelectCity: 'Select Address Form City',
    trackSelectState: 'Select Address Form State',
    trackSelectZip: 'Select Address Form Zip Code',
    trackClickAgeWarning: 'Click Age Warning Checkbox',
    trackClickPrimaryCareWarning: 'Click Primary Care Warning Checkbox',
    trackClickObgynWarning: 'Click OBGYN Warning Checkbox',
    trackSelectReferringPhysician: 'Select Referring Physician',
    trackShowRequiredAddressField: 'Show Required Address Field',
    trackClickUsingInsuranceWarning: 'Click Using Insurance Warning Checkbox',
};

export const warningMapping = {
    [PRIMARY_CARE_WARNING]: PRIMARY_CARE_CONFIRMATION_STATE_KEY,
    [OBGYN_WARNING]: OBGYN_CONFIRMATION_STATE_KEY,
    [AGE_WARNING]: AGE_WARNING_CONFIRMATION_STATE_KEY,
    [REFERRAL_REQUIRED]: REFERRING_PHYSICIAN_STATE_KEY,
    [USING_INSURANCE_WARNING]: USING_INSURANCE_STATE_KEY,
};

export const APPOINTMENT_REQUIREMENTS_STRINGS = {
    AddressRequired: 'Please type your address.',
    ReferringPhysicianRequired:
        'Please enter the name of your referring physician.',
    MustConfirmPcp: 'You must confirm that this is your primary care doctor.',
    MustConfirmedObgyn: 'You must confirm that the patient is female.',
    MustConfirmedAge: 'Please confirm that you want to make this appointment.',
};

export const USING_INSURANCE_WARNING_ERROR_STRING =
    'You must confirm you are booking with this insurance.';
